export const loginDrawerOverlayId = "login-drawer";
export const signupDrawerOverlayId = "signup-drawer";
export const resetPasswordDrawerOverlayId = "reset-password-drawer";
